import {useStripe} from '@stripe/react-stripe-js'
import {organizationApiClient} from 'organization/organizationApiClient'
import {useLocalizedNavigate} from 'i18n/useLocalizedNavigate'
import {useI18n} from 'i18n/I18nContext'
import {toast} from 'react-toastify'
import {routes} from 'routes/routes'

export default function usePayment() {
  const {t} = useI18n()
  const navigate = useLocalizedNavigate()
  const stripe = useStripe()
  const apiClient = organizationApiClient()

  const confirmTicketPayment = async (
    clientSecret: string,
    intentId: string,
    confirmationUrl: string,
    requestData: {
      [x: string]: any
    },
    onSuccess: () => void,
  ) => {
    if (!stripe) return
    const {error} = await stripe.handleNextAction({
      clientSecret: clientSecret,
    })

    if (error) {
      toast.warning(t('payment.failed'))
    } else {
      // notify back and confirm payment in back

      await apiClient
        .post(confirmationUrl, {
          ...requestData,
          intentId,
        })
        .then((result) => {
          toast.success(t('payment.success'))
          onSuccess()
        })
        .catch((err) => {
          toast.warning(t('payment.failed'))
        })
    }
  }

  const newPayment = (
    url: string,
    confirmationUrl: string,
    requestData: {
      [x: string]: any
    },
    onSuccess: () => void,
  ) => {
    return async (paymentMethodId: string) => {
      await apiClient
        .post(url, {
          ...requestData,
          paymentMethodId,
        })
        .then(() => {
          onSuccess()
        })
        .catch(async (data) => {
          if (data.response.status === 401) {
            navigate(routes.organization.login)
          }
          if (data.response.status === 471) {
            await confirmTicketPayment(
              data.response.data.client_secret,
              data.response.data.intent_id,
              confirmationUrl,
              requestData,
              onSuccess,
            )
          }

          toast.warning(data.response.data.message)
        })
    }
  }

  return {
    newPayment,
  }
}
